"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react2 = require("@prismicio/react");

var _Checkbox = _interopRequireDefault(require("../../shared/components/Checkbox/Checkbox"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase, id-blacklist */
var Programs = function ProgramsComponent(_ref) {
  var programs = _ref.programs,
      selectProgram = _ref.selectProgram,
      selectedPrograms = _ref.selectedPrograms;
  return programs.map(function (_ref2) {
    var uid = _ref2.uid,
        _ref2$data = _ref2.data,
        program_name = _ref2$data.program_name,
        post_purchase_recommendation_blurb = _ref2$data.post_purchase_recommendation_blurb;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: uid,
      className: "recommended-programs__card"
    }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      id: uid,
      label: "",
      checked: !!selectedPrograms[uid],
      onClick: function onClick() {
        return selectProgram(uid);
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "recommended-programs__card-body"
    }, /*#__PURE__*/_react["default"].createElement("h1", {
      className: "recommended-programs__card-header"
    }, /*#__PURE__*/_react["default"].createElement(_react2.PrismicText, {
      field: program_name
    })), /*#__PURE__*/_react["default"].createElement("p", {
      className: "recommended-programs__card-info"
    }, /*#__PURE__*/_react["default"].createElement(_react2.PrismicText, {
      field: post_purchase_recommendation_blurb
    }))));
  });
};

Programs.propTypes = {
  programs: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  selectProgram: _propTypes["default"].func.isRequired,
  selectedPrograms: _propTypes["default"].shape({}).isRequired
};
var _default = Programs;
exports["default"] = _default;